import { Image, Text } from "@clipboard-health/ui-react";
import { isDefined } from "@clipboard-health/util-ts";
import { Button, Stack } from "@mui/material";
import cbhBunnyLogo from "@src/appV2/lib/assets/images/cbhBunny.svg";
import { isSameDay, parseISO } from "date-fns";
import { Link } from "react-router-dom";

import { useMyShiftsMaxEarnings } from "../../MyShiftUnavailable";
import { formatRate } from "../utils";
import { ShiftCardLoadingPlaceholder } from "./ShiftCardLoadingPlaceholder";

export function EmptyMyShiftsPlaceholder() {
  const { isLoading: isLoadingMaxEarnings, data: maxEarnings } = useMyShiftsMaxEarnings();

  if (isLoadingMaxEarnings) {
    return <ShiftCardLoadingPlaceholder />;
  }

  const { amount = 0, date } = maxEarnings ?? {};

  return (
    <Stack alignItems="center" spacing={2}>
      <Image alt="Clipboard Health logo" src={cbhBunnyLogo} width="160px" />
      {amount === 0 ? (
        <Stack>
          <Text variant="body2" textAlign="center">
            There are no available shifts nearby for you to book.
          </Text>
          <Text variant="body2" textAlign="center">
            Expand your distance preferences in My Account or check back later when more shifts
            become available.
          </Text>
        </Stack>
      ) : (
        <Stack spacing={2}>
          <Stack>
            <Text variant="body2" textAlign="center">
              You have not booked any upcoming shifts!
            </Text>
            <Text variant="body2" textAlign="center">
              Go to Find Shifts to start booking now
            </Text>
            <Text variant="body2" textAlign="center">
              Earn up to <b>{formatRate(amount)}</b> per shift
              {isDefined(date) && isSameDay(new Date(), parseISO(date)) ? <b> today</b> : null}!
            </Text>
          </Stack>
          <Button
            component={Link}
            to="/home/openShifts"
            variant="contained"
            color="primary"
            sx={{
              boxShadow: "none",
            }}
          >
            Find Shifts
          </Button>
        </Stack>
      )}
    </Stack>
  );
}
